export const API = {
    AUTH: {
        SIGNUP: "/api/signup",
        LOGIN: "/api/login",
        LOGOUT: "/api/logout",
        VERIFICATION: "/api/verification",
        ADDRESS: "/api/user/address",
        UPDATE: "/api/user"
    },
    PRODUCT: {
        PRODUCTLISTS: "/api/product",
        PRODUCTDETAIL: "/api/product",
        PRODUCTFILTER: "/api/products/filter",
        PRODUCTCOLLECTION: "/api/collection/product",
        PRODUCTSALE: "/api/discounts/product",
        CATEGORYDETAILS: "/api/products/category/details",
        CUSTOMIZE: "/api/product/customize",
        GET_VAULT_PRODUCTS: "/api/product/vault",
        GET_DISPLAY_PRODUCTS: "/api/product/display",
        GET_BEST_PRODUCTS: "/api/product/bestseller",
        RECOMMENDED_PRODS: "/api/products/recommended",
        GET_SEND_DESIGN_PRODUCTS: "/api/product/senddesign",
    },
    WHISHLIST: {
        ADD: "/api/wishlist",
        DELETE: "/api/wishlist",
        GET: "/api/wishlist",
    },
    ORDER: {
        GET: "/api/order",
        POST: "/api/order",
        VERIFY: "/api/order/verify"
    },
    CART: {
        GET: "/api/cart",
        UPDATE: "/api/cart",
        DELETE: "/api/cart",
        CHECKOUT: "/api/checkout/cart"
    },
    COUPON: {
        GET: "/api/coupon/filter",
    },
    CATEGORY: {
        GET: "/api/category"
    },
    COLLECTION: {
        GET: "/api/collections"
    },
    COLORS: {
        GET: "/api/colors"
    },
    APPOINTMENT: {
        GET: "/api/appointment/calender",
        CREATE: "/api/appointment-create",
        UNBLOCKDATE: "/api/unblock-date",
        MY: "/api/appointment/my",
        UPDATE_STATUS: "/api/appointment/update-status"
    },
    CMS: {
        GET: "/api/admin",
        UPDATE: "/api/admin",
        DELETE: "/api/admin",
        GET_ALL: "/api/admin",
        CREATE: "/api/admin"
    }
  };